import { Fields } from '@/lib/PlanFields'

export const FilterType = {
  Department: 'department',
  Role: 'role',
  Level: 'level',
  Location: 'officeLocation',
  Manager: 'manager',
  CustomField: 'customField',
  CustomFieldV2: 'customFieldv2',
  ScenarioStatus: 'scenarioStatus',
  WorkforceStatus: 'workforceStatus',
  SensitiveData: 'sensitiveData',
  PositionPlanning: 'positionPlanning',
  PositionPlanningScenarioPositions: 'positionPlanningScenarioPositions',
  SpanOfControl: 'spanOfControl',
  StartDateRange: 'startDateRange',
  EndDateRange: 'endDateRange'
}

export const calculatedFields = [
  FilterType.Level,
  FilterType.WorkforceStatus,
  FilterType.PositionPlanning,
  FilterType.PositionPlanningScenarioPositions,
  FilterType.ScenarioStatus,
  FilterType.SpanOfControl,
  FilterType.Manager,
  FilterType.ScenarioStatus
]

export const dateRangeFields = [FilterType.StartDateRange, FilterType.EndDateRange]

export const isDateRangeCategory = (filterOrId) => {
  const id = typeof filterOrId === 'string' ? filterOrId : filterOrId?.id
  return dateRangeFields.includes(id)
}

export const upsertDateRangeFilter = (filterData, filters = []) => {
  const nextFilters = filters.filter((filter) => filter.type !== filterData.type)
  nextFilters.push(filterData)
  return nextFilters
}

export const clearDateRangeFilter = (filterType, filters = []) =>
  filters.filter((filter) => filter.type !== filterType)

export const getDisplayFieldForDateRange = (filterType) => {
  if (filterType === FilterType.StartDateRange) return Fields.startDate
  if (filterType === FilterType.EndDateRange) return Fields.endDate
  return null
}
